module.exports = __webpack_public_path__ + "img/webwxgetmsgimg.00960f70.png";